<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid overflow-auto pt-5 mt-5" style="max-height: 860px;">

        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Payer Creation</h1>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-xl-12 col-md-12 mb-2">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary  mb-1">
                                    <form [formGroup]="payerForm" (ngSubmit)="onRegister()">
                                        <div class="row">
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Name</mat-label>
                                                        <input matInput formControlName="name" minlength="3" placeholder="Payer name (Payer-Code)" title="Name at least has 3 characters !">
                                                        <mat-error *ngIf="payerForm.controls.name.errors?.required">This field is required !</mat-error>
                                                        <mat-error *ngIf="payerForm.controls.name?.value">Name at least has 3 characters !</mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Payer-Code</mat-label>
                                                        <input matInput formControlName="payerIdCode" placeholder="Payer-Code" >
                                                        <mat-error *ngIf="payerForm.controls.payerIdCode.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" routerLink="/payer"
                                                class="btn btn-secondary float-end  waves-effect waves-light">Cancel</button>
                                        <button *ngIf="!PayerId" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit"
                                                [disabled]="!payerForm.valid">Register
                                        </button>
                                        <button *ngIf="PayerId" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit"
                                                [disabled]="!payerForm.valid">Update
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
